import React,{useState,useEffect} from 'react';
import PropTypes from 'prop-types';
import { withStyles,makeStyles, useTheme } from '@material-ui/core/styles';

import FirstPageIcon from '@material-ui/icons/FirstPage';
import KeyboardArrowLeft from '@material-ui/icons/KeyboardArrowLeft';
import KeyboardArrowRight from '@material-ui/icons/KeyboardArrowRight';
import {Search,AlarmOutlined,AirportShuttleOutlined,SubwayOutlined,Send,AirlineSeatReclineNormal,Money,AirportShuttle,PersonOutlined,LastPage,AllInclusive,Add,MoreVert,Schedule,Block,Edit,Delete,Place,WbIncandescentOutlined,ArrowDropDown,DevicesOtherOutlined,AccountBalanceWalletOutlined,ConfirmationNumberOutlined,CancelPresentation} from '@material-ui/icons';

import ScheduleIcon from '@material-ui/icons/Schedule';

import {
  ListItemText,
  TableRow ,
  TablePagination,
  TableFooter,
  TableContainer,
  TableCell,
  TableBody,
  Table ,
  TableHead,
  Button,
  IconButton,
  Paper,
  Typography,
  Toolbar,
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  AppBar,
  TextField,
  FormControlLabel,
  Checkbox,
  Container ,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Menu,
  TextareaAutosize,
  LinearProgress,
  FormHelperText,
  CircularProgress,
  Grid,
  Chip,
  Link ,
  useMediaQuery,
  ListItemIcon,
  List,
  ListItem,
  ListSubheader,
  ButtonGroup
} from "@material-ui/core";

import { withLocalize,Translate } from "react-localize-redux";
import { MuiPickersUtilsProvider, DatePicker,TimePicker,KeyboardTimePicker, DateTimePicker} from "@material-ui/pickers";
import MUIDataTable from "mui-datatables";
import API from './api';

import { useSnackbar } from 'notistack';
import { setDayWithOptions } from 'date-fns/fp';


import MaskedInput from "react-text-mask";


import Autocomplete from '@material-ui/lab/Autocomplete';

import UserInfo from "./login_info";

import axios from 'axios';
import Format from "date-fns/format";
import DateFnsUtils from "@date-io/date-fns";

import {TransportService,ReportingService} from "./../../utils/web_config_2";
import { set } from 'date-fns/esm';
import Manifesto from "../../assets/svg/bus-stop.svg";
import bus from "../../assets/svg/bus.svg";
import route from "../../assets/svg/route.svg";

import passenger from "../../assets/svg/passenger_bus.svg";
import money from "../../assets/svg/total_amount.svg";
import iticketdetails from "../../assets/svg/ticket_details.svg";

import TicketS from "../../assets/svg/ticket_search.svg"


import trip from "../../assets/svg/trip.svg";

import Chart from 'react-apexcharts';


const useStyles1 = makeStyles((theme) => ({
    root: {
      flexShrink: 0,
      flexFlow:1,
      [theme.breakpoints.up('sm')]:{
        marginLeft:250,
      }
    },
    btn:{
      textTransform:"capitalize",
  
    },
    formTitle:{
      flexGrow:1,
  },paper: {
    padding: theme.spacing(2),
    textAlign: 'center',
    color: theme.palette.text.secondary,
    elevation:0
  },
  paper1: {
    color: theme.palette.text.secondary,
    height:240,
    elevation:0
  },
  }));
  


  const TextMaskCustom = (props) => {
    const { inputRef, ...other } = props;
  
    return (
      <MaskedInput
        {...other}
        ref={inputRef}
        mask={[/[0-2]/, /[0-9]/, ':', /[0-5]/, /[0-9]/]}
        placeholderChar={'\u2000'}
        showMask
      />
    );
  }
  
  TextMaskCustom.propTypes = {
    inputRef: PropTypes.func.isRequired,
  };
  


function TicketSearch(){
    const classes = useStyles1();
    const [operatorData, setOperatorData] = useState({});

    useEffect(()=>{

        var data = {};
        const data1 = localStorage.getItem("nx_op");
        if (data1 != null) {
          data = JSON.parse(data1);
        }
    
        setOperatorData(data);
        
        
      },[]);


     

      // ticket table 

      const [message,setMessage]=useState("Search Ticket");

      const columns = [
        {
          name: "route",
          label: "Route",
          options: {
            display:true,
           filter: true,
           sort: true,
          }
         },
        {
         name: "passenger",
         label: "Passenger",
         options: {
          filter: true,
          sort: true,
         }
        },{
         name: "from",
         label: "From",
         options: {
          filter: true,
          sort: false,
         }
        },
        {
          name: "to",
          label: "To",
          options: {
           filter: true,
           sort: false,
          }
         },{
          name: "amount_paid",
          label: "Amount",
          options: {
           filter: true,
           sort: true,
          }
         },{
          name: "currency",
          label: "Currency",
          options: {
           filter: true,
           sort: true,
          }
         },
         {
            name: "date_time",
            label: "Date Time",
            options: {
             filter: true,
             sort: true,
            }
           },
           {
            name: "ticket_generated_by",
            label: "Generated By",
            options: {
             filter: true,
             sort: true,
            }
           },
           {
            name: "device_id",
            label: "Device ID",
            options: {
             filter: true,
             sort: true,
            }
           },
           {
            name: "promotion_code",
            label: "Promotion Code",
            options: {
             filter: true,
             sort: true,
            }
           }
       ];

       const options = {
        textLabels: {
          body: {
            noMatch: message
          },
        },
         filterType: 'checkbox',
         download:true,
         responsive:"standard",
         selectableRows:false,
         rowsPerPage: 10,
         elevation:0
       };


      // query ticket

      const [method,setMethod]=useState("ID");

      const [loading,setLoading]=useState(false);
      const [ticket,setTicket]=useState([]);

      const [ticketId,setTicketId]=useState({value:"",error:""});

      const [description,setDescription]=useState("");


      const searchTicket=()=>{
        if(ticketId.value!=""){
        setLoading(true);
        setTicket([]);
        setDescription("");
        axios.defaults.baseURL = new ReportingService().BASE_URL;
        const tripInstance = axios.create(new ReportingService().setHeaders(operatorData.token));
        tripInstance.get('/extra-reports/findTicketByNumber/'+ticketId.value,
        {}).then(res=>{
          setLoading(false);

          let data=res.data.data;
          if(data!=null){
            setDescription("Ticket ID :"+ticketId.value);
              let t=[];
              t.push(data);
              setTicket(t);
          }else{
            setMessage("Ticket not found");
          }
        

        })
        .catch(err=>{
          setLoading(false);
        });

        }else{

        }
        
      }


      /// search ticket by code 


      const [refferenceNumber,setReffenceNumber]=useState({value:"",error:""});
      const [fromDate,setFromDate]=useState({value:Format(new Date(), ["yyyy-MM-dd",]),error:""});
      const [toDate,setToDate]=useState({value:Format(new Date(), ["yyyy-MM-dd",]),error:""});

      const [fromTime,setFromTime]=useState({value:Format(new Date(),["HH:mm"]),error:""});
      const [toTime,setToTime]=useState({value:Format(new Date(),["HH:mm"]),error:""});



      const getTickets=()=>{

        if(refferenceNumber.value!=""){
          setLoading(true);
          setTicket([]);
          setDescription("Tickets => "+refferenceNumber.value);
        axios.defaults.baseURL = new ReportingService().BASE_URL;
        const tripInstance = axios.create(new ReportingService().setHeaders(operatorData.token));
        tripInstance.post('/extra-reports/pullCustomerPurchaseDetails',
        {
          "from": fromDate.value+" "+fromTime.value+":00",
          "refference_number": refferenceNumber.value,
          "to": toDate.value+" "+toTime.value+":00"
        }).then(res=>{
          setLoading(false);
          // console.log("== vehicles ==",res.data);
          let data=res.data.data;
          if(data.length==0){
            setMessage("No Tickets Available");
          }else{
            setTicket(data);
          }
         

        })
        .catch(err=>{
          setLoading(false);
        });

        }else{

        }
        
      }




    return(

        <MuiPickersUtilsProvider utils={DateFnsUtils}>
        <div className={classes.root}>
          <Box display="flex">
     
     <Box display="flex" alignItems="center" mt={2} className={classes.formTitle}>
     
     <Box mr={1}><img src={TicketS} width="40px" height="40px"/> </Box> <Typography  variant="h5" color="default"><b>Search Ticket Summary</b></Typography>
    
     </Box>


         </Box>

<Box mt={2}>
         <Grid container spacing={1}>
           <Grid item md={4} lg={4} sm={12} xs={12}>

{method=="ID"&&


<Paper className={classes.paper} elevation={0}>
               
<Box>

    <Box display="flex" alignContent="center" alignItems="center">
    <ButtonGroup fullWidth color="primary" aria-label="outlined primary button group">
<Button className={classes.btn} disableElevation variant={method=="ID"?"contained":"outlined"} onClick={()=>{
setMethod("ID");
}}>By Ticket ID</Button>
<Button className={classes.btn} disableElevation variant={method=="CODE"?"contained":"outlined"} onClick={()=>{
setMethod("CODE");
}}>By Client Code</Button>
</ButtonGroup>
    </Box>
    
<Box mt={1} display='flex' alignItems='center' justifyContent='center'>
<TextField size='small' variant='outlined' label="Ticket ID" onChange={(e)=>{
  if(e.target.value===""){
    setTicketId({value:"",error:"Enter Ticket ID"});
  }else{
    setTicketId({value:e.target.value,error:""});
  }
}}  
color='primary'
error={ticketId.error!==""}
helperText={ticketId.error}
fullWidth    
/>
</Box>


<Box mt={1} display='flex' alignItems='center' justifyContent='center'>
<Button
className={classes.btn}
size="small"
variant="contained"
color="primary"
disableElevation
fullWidth
disabled={loading}
onClick={()=>{
    searchTicket();
}}
>
{loading?<CircularProgress color="secondary" size={23} />:"Search Ticket"}

</Button>
</Box>


   </Box>
 </Paper>
}


{method=="CODE"&&
   <Paper className={classes.paper} elevation={0}>
               
   <Box >

   <Box display="flex" alignContent="center" alignItems="center">
    <ButtonGroup fullWidth color="primary" aria-label="outlined primary button group">
<Button className={classes.btn} disableElevation variant={method=="ID"?"contained":"outlined"} onClick={()=>{
setMethod("ID");
}}>By Ticket ID</Button>
<Button className={classes.btn} disableElevation variant={method=="CODE"?"contained":"outlined"} onClick={()=>{
setMethod("CODE");
}}>By Client Code</Button>
</ButtonGroup>
    </Box>
   <Box mt={1} display='flex' alignItems='center' justifyContent='center'>
<TextField size='small' variant='outlined' label="Client Code" onChange={(e)=>{
  if(e.target.value===""){
    setReffenceNumber({value:"",error:"Enter client code"});
  }else{
    setReffenceNumber({value:e.target.value,error:""});
  }
}}  
color='primary'
error={refferenceNumber.error!==""}
helperText={refferenceNumber.error}
fullWidth    
/>
</Box>
<Box mt={1} display='flex' alignItems='center' justifyContent='center'>
<Grid container>

<Grid item item md={8} lg={8} sm={8} xs={8}>

<Box>
<DatePicker
fullWidth
disableToolbar
variant="inline"
format="yyyy-MM-dd"
margin="dense"
disableFuture
autoOk
label="From Date"
value={fromDate.value}
inputVariant="outlined"
onChange={(v)=>{
  // console.log("choosen2: ",v);
  setFromDate({value:Format(v, ["yyyy-MM-dd"]),error:""});
}}
InputProps={{
disableUnderline: true,
style: { paddingRight: 1 },
}}
/>
</Box>
</Grid>
<Grid item item md={4} lg={4} sm={4} xs={4}>
<Box>
<Box ml={1} mt={1}>

<TextField
fullWidth
size="small"
defaultValue={fromTime.value}
// label="From Time"
variant="outlined"
InputProps={{
inputComponent: TextMaskCustom,
value:fromTime.value,
onChange: (e)=>{
setFromTime({value:e.target.value,error:""});
},
}}
/>

</Box>
</Box>
</Grid>

</Grid>
</Box>


<Box mt={1} display='flex' alignItems='center' justifyContent='center'>
<Grid container>

<Grid item item md={8} lg={8} sm={8} xs={8}>

<Box>
<DatePicker
fullWidth
disableToolbar
variant="inline"
format="yyyy-MM-dd"
margin="dense"
disableFuture
autoOk
label="To Date"
value={toDate.value}
inputVariant="outlined"
onChange={(v)=>{
  // console.log("choosen2: ",v);
  setToDate({value:Format(v, ["yyyy-MM-dd"]),error:""});
}}
InputProps={{
disableUnderline: true,
style: { paddingRight: 1 },
}}
/>
</Box>
</Grid>
<Grid item item md={4} lg={4} sm={4} xs={4}>
<Box>
<Box ml={1} mt={1}>

<TextField
fullWidth
size="small"
defaultValue={toTime.value}
// label="From Time"
variant="outlined"
InputProps={{
inputComponent: TextMaskCustom,
value:toTime.value,
onChange: (e)=>{
setToTime({value:e.target.value,error:""});
},
}}
/>

</Box>
</Box>
</Grid>

</Grid>
</Box>

<Box mt={1} display='flex' alignItems='center' justifyContent='center'>
<Button
className={classes.btn}
size="small"
variant="contained"
color="primary"
disableElevation
fullWidth
disabled={loading}
onClick={()=>{
getTickets();
}}
>
{loading?<CircularProgress color="secondary" size={23} />:"Search Tickets"}

</Button>
</Box>


   </Box>
 </Paper>

}

           
           
           
           </Grid>

           <Grid item md={8} lg={8} sm={12} xs={12}>
         <Paper className={classes.paper} elevation={0}>
              <Box >
          {loading&&<LinearProgress />}
          <MUIDataTable
            title={description}
            data={ticket}
            columns={columns}
            options={options}
          />
            </Box>
            </Paper>
         </Grid>


         </Grid>

         
</Box>

         </div>
         </MuiPickersUtilsProvider>

    );
}

export default  withLocalize(TicketSearch);